import React from 'react';
import cn from 'bem-cn';
import { Icon } from '../UI';

import type { ChapterCardProps } from './ChapterCard.types';

import './ChapterCard.scss';

const b = cn('chapter-card');

export const ChapterCard: React.FC<ChapterCardProps> = ({ chapter, className }) => {
    // Используем order_number из данных главы, если есть, иначе показываем ID
    const displayNumber = chapter.order_number ?? chapter.id;

    return (
        <div className={b({}, [className])}>
            <div className={b('image-container')}>
                {chapter.cover_image_url ? (
                    <img src={chapter.cover_image_url} alt={chapter.name} className={b('image')} />
                ) : (
                    <div className={b('image-placeholder')} />
                )}
                <Icon name="play" className={b('play-icon')} />
            </div>
            <div className={b('content')}>
                <div className={b('content-header')}>
                    <div className={b('chapter-number')}>Глава {displayNumber}</div>
                    <div className={b('duration')}>{chapter.chapter_time}</div>
                </div>
                <h3 className={b('title')}>{chapter.name}</h3>
                <p className={b('description')}>{chapter.description}</p>
            </div>
        </div>
    );
};
